import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useDebouncedCallback } from "use-debounce";

const AddressLookup = ({ onSubmit, error }) => {
  const [term, setTerm] = useState("");
  const [suggestions, setSuggestions] = useState(null);

  const fetchSuggestions = useDebouncedCallback(async (term) => {
    const result = await fetch(`${api.url}/address-lookup?term=${term}`);
    const data = await result.json();

    setSuggestions(data);
  }, 500);

  useEffect(() => {
    if (term.length < 3) {
      setSuggestions(null);
    } else {
      fetchSuggestions(term);
    }
  }, [term]);

  const handleAddress = async (id) => {
    const result = await fetch(`${api.url}/address-lookup/${id}`);
    const data = await result.json();

    onSubmit(data);
  };

  return (
    <div className={clsx("form-group", "required", error && "invalid")}>
      <label className="form-label" htmlFor="AddressLookup">
        Address
      </label>
      <input
        type="text"
        placeholder="Search address..."
        className="form-control"
        value={term}
        onChange={(e) => setTerm(e.target.value)}
        autoComplete="off"
        autoComplete="chrome-off"
      />
      {suggestions && (
        <ul className="form-autocomplete" aria-expanded="true">
          {!suggestions.length && (
            <li className="no-results">
              <em>No addresses found</em>
            </li>
          )}

          {suggestions.map((suggestion) => (
            <li key={suggestion.id}>
              <button
                type="button"
                onClick={() => handleAddress(suggestion.id)}
              >
                {suggestion.address}
              </button>
            </li>
          ))}
        </ul>
      )}
      {error && <div className="invalid-feedback">{error.message}</div>}
    </div>
  );
};

export default AddressLookup;
